<template>
<div class="akl">
  <!-- 레이어 팝업 : 눈 건강 자가진단 .pop_eyecare -->
  <div class="layerWrapper pop_eyecare" tabindex="0" style="display: none;"><!-- @레이어 이름 -->
    <div class="cbox layerBox popWidM" style=""><!-- @팝업 사이즈 600px : popWidM -->
      <TripleEyeIntro v-if="showMode===0"
      @clickStart="start"/>
      <TripleEyeQuest1 v-if="showMode===1"
      @clickNext="goNext"/>
      <TripleEyeQuest2 v-if="showMode===2"
      :selectedScore="selectedScore"
      @clickNext="goResult"/>
      <TripleEyeResult v-if="showMode===3"
      :score="score"
      :devMode="devMode"
      @clickResult="goRoulette"
      @clickReset="init"/>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import 'bootstrap'

import TripleEyeIntro from './component/intro.vue'
import TripleEyeQuest1 from './component/quest1.vue'
import TripleEyeQuest2 from './component/quest2.vue'
import TripleEyeResult from './component/result.vue'

export default {
  name: 'tripleEyeCare',
  components: {
    TripleEyeIntro,
    TripleEyeQuest1,
    TripleEyeQuest2,
    TripleEyeResult
  },
  data () {
    return {
      showMode: Number,
      score: Number,
      selectedScore: Array,
      devMode: Boolean
    }
  },
  methods: {
    init: function () { // 초기화
      this.showMode = 0
      this.score = ''
      this.selectedScore = [...arguments]
      this.devMode = false
    },
    isOpen: function () {
      let dt = new Date()
      if (dt.getFullYear() === 2021 && dt.getMonth() >= 1 && dt.getDate() <= 5) {
        this.start()
      } else {
        alert('2021-02-05일부로 종료되었습니다.')
      }
    },
    start: function () { // 질문 시작
      this.score = 1
      this.selectedScore = ['', '', '', '', '', '', '', '', '', '', '', '']
      this.showMode = 1
      this.devMode = (process.env.NODE_ENV === 'prod' ? false : true)
    },
    goNext: function () { // 다음 페이지
      this.showMode = this.showMode + 1
    },
    goResult: function () { // 결과보기
      let answerCount = 0
      let answerPoint = 0
      this.score = 0
      this.selectedScore.forEach(element => {
        if (element > -1) {
          answerPoint += Number(element)
          answerCount += 1
        }
      }, this)
      this.score = Math.floor(answerPoint * 25.0 / answerCount * 100) / 100
      this.showMode = this.showMode + 1

    },
    goRoulette: function () { // 응모하기
      // window.location.href = process.env.TRIPLE_EYE_CARE_EXT_URL
      window.open(process.env.TRIPLE_EYE_CARE_EXT_URL)
    }
  },
  mounted: function () {
    this.isOpen()
  },
  created: function () {
    $(function () {
      // eslint-disable-next-line
      window.setTimeout(function () {
        layerPopOver( '', '.pop_eyecare')
      }, 500);
    })
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+KR:300,400,500,700&subset=korean');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/style.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-lib.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/base.css');
@import url('https://www.amway.co.kr/_ui/responsive/theme-blue/css/akl-common.css');

/* @import 'font_kr.css'; */
.bt-whpop-gray{background-color:gray !important;border-color:gray !important;color:#fff !important;width:45%}
.bt-whpop-purple{width:45%}
</style>



// WEBPACK FOOTER //
// src/views/triple-eye-care/tripleEyeCare.vue